import { useEditorFile } from "../../../../../hooks";
import DxmlElement from "../DxmlElement";
import * as Constants from "../../../../../utils/constants";

export default function DxmlElements({ editorBaseModel }) {
    const { getChildItemsToShow, getKeyById } = useEditorFile();
    const elementsToShow = getChildItemsToShow(editorBaseModel);

    const elementClassnNames = (element, index) => {
        const spaceY = "tw-mb-3";
        if (index === (elementsToShow.length - 1))
            return "";

        if (element.Type !== Constants.editorType.table)
            return spaceY;

        if (elementsToShow[index + 1].Type === Constants.editorType.table)
            return "";

        return spaceY;
    }

    return (
        <div className="">
            {
                elementsToShow.map((element, index) => (
                    <div
                        key={getKeyById(element)}
                        className={elementClassnNames(element, index)}
                    >
                        <DxmlElement editorBaseModel={element} />
                    </div>
                ))
            }
        </div>
    )
}